
define('txt!tmpl/generic.fail.hbs',[],function () { return '{{{headline}}}\n{{{message}}}\n';});

